import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import { captureAffiliateFromSearch } from "./utils/affiliateTracking";

// Only initialize if a GA measurement ID is provided (react-ga4 throws on empty string)
if (process.env.REACT_APP_GAID) {
  ReactGA.initialize(process.env.REACT_APP_GAID);
}

const withTracker = (WrappedComponent, options = {}) => {
  const BASENAME = process.env.REACT_APP_BASENAME || "";

  // Create functional component that uses hooks
  const WithTrackerComponent = (props) => {
    const location = useLocation();

    useEffect(() => {
      const trackPage = () => {
        captureAffiliateFromSearch(location.search);

        if (process.env.NODE_ENV !== "production") {
          return;
        }
        if (!process.env.REACT_APP_GAID) {
          return;
        }

        const page = location.pathname + location.search;
        ReactGA.send({ hitType: "pageview", page: `${BASENAME}${page}`, ...options });
      };

      trackPage();
    }, [location, options]);

    return <WrappedComponent {...props} />;
  };

  WithTrackerComponent.displayName = `withTracker(${WrappedComponent.displayName || WrappedComponent.name || "Component"})`;

  return WithTrackerComponent;
};

export default withTracker;
